import { css, StyleSheet } from 'aphrodite/no-important';
import * as React from 'react';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export const ContentWidthLayout = (props) => {
    const containerClass = [props.className || '', css(styles.container)].join(' ');
    return (React.createElement("div", { className: containerClass, id: props.id }, props.children));
};
const ContainerSize = {
    xs: 'calc(100% - 1rem * 2)',
    md: 'calc(100% - 1rem * 2)',
    lg: 'calc(100% - 2rem * 2)',
    xl: '1010px',
};
const styles = StyleSheet.create({
    container: {
        margin: '0 15px',
        [MediaBreakPointUp.MD]: {
            margin: '0 auto',
            width: ContainerSize.md,
        },
        [MediaBreakPointUp.LG]: {
            width: ContainerSize.lg,
        },
        [MediaBreakPointUp.XL]: {
            width: ContainerSize.xl,
        },
    },
});
